module.exports = __webpack_public_path__ + "img/treatments-history-desktop-fr.fc893d38.jpg";